export function isLaunchedInFrame() {
  const route: any = useRoute();
  return route?.query?.iframe && route?.query?.iframe === '1';
}

export function isLaunchedFromRixos() {
  const route: any = useRoute();
  return (
    route?.query?.partner_id &&
    route?.query?.partner_id !== '' &&
    route?.query?.origin &&
    route?.query?.origin !== ''
  );
}
